import { render, staticRenderFns } from "./student-status.vue?vue&type=template&id=18df4ced&scoped=true&"
import script from "./student-status.vue?vue&type=script&lang=js&"
export * from "./student-status.vue?vue&type=script&lang=js&"
import style0 from "./student-status.vue?vue&type=style&index=0&id=18df4ced&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df4ced",
  null
  
)

export default component.exports